import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4.905 12.914a5.33 5.33 0 0 0 5.644 1.222l.179-.067a1.333 1.333 0 0 0 .474-2.191l-.926-.927a1.333 1.333 0 0 0-1.886 0l-.447.448c-.52.52-1.365.52-1.886 0L4.61 9.951a1.333 1.333 0 0 1 0-1.885l.448-.448c.52-.52.52-1.365 0-1.886l-.926-.926a1.333 1.333 0 0 0-2.191.475l-.068.179a5.33 5.33 0 0 0 1.223 5.644zm4.407-7.165-.387 1.606c-.108.448.355.812.742.583L11 7.148l1.333.79c.387.229.85-.135.742-.583l-.387-1.606 1.13-.975c.34-.294.177-.867-.262-.924l-1.543-.2-.548-1.324a.5.5 0 0 0-.93 0L9.987 3.65l-1.543.2c-.44.057-.602.63-.261.924z"
    }
  )
);
var SvgPhoneStar = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PhoneStar_default = SvgPhoneStar;

export { PhoneStar_default as default };
